import { memo } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { round } from 'mathjs';
import allStyles from '../../AllCharts.module.css';
import styles from './UserScore.module.css';
import type { UiOptionsData } from '../../../../config/types/context.types';

type Props = {
  userScore: number;
  optionsData: UiOptionsData;
  setUserScorePopup: Dispatch<SetStateAction<boolean>>;
};

const UserScore = memo(({ userScore, optionsData, setUserScorePopup }: Props) => {
  const alertLevel = 'alertLevel' + round(((100 - userScore) * 4.9999) / 100);

  return (
    <div
      className={styles.userScoreWrapper}
      onClick={() => setUserScorePopup(true)}
    >
      <div
        className={allStyles.chartInnerCard}
        style={{
          // `alertLevel` is built dynamically; index the typed colour keys.
          backgroundColor: optionsData[alertLevel as `alertLevel${number}`],
          color: 'white',
          height: '100%'
        }}
      >
        <div className={styles.userScoreInnerContainer}>
          <h1>{userScore}%</h1>
          <h3>Share Your Score</h3>
        </div>
      </div>
    </div>
  );
});

export default UserScore;
